module.exports = __webpack_public_path__ + "img/defaultHeadimg.161a90f6.jpeg";